import styled from 'styled-components';

export const Container = styled.div`
  width: 90%;
  max-width: 1024px;
  margin: 30px auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 20px;
`;
